export class SgsTuvUpdateRequest{
    sgsTuvId: number;
}